export default __webpack_public_path__ + "static/media/logo.fac64494.svg";